<ul class="list-group" *ngFor="let userAgent of list">
    <li class="list-group-item">
        <b>Rendszer:</b> {{ userAgent.agentFamily }}
        <b>Device:</b> {{ userAgent.deviceFamily }}
        <b>Böngésző:</b> {{ userAgent.agentFamily }}
        <b>Első használat:</b> {{ userAgent.createdAt.toLocaleString() }}
    </li>
  </ul>
